import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO/SEO';
import contentData from '../data/contentData.json';
import BlogCard from '../components/BlogCard';

const BlogPage = () => {
  const blogs = contentData.blogs || [];

  // SEO data for Blog page
  const seoData = {
    title: "Blog - Cloud Technology Insights",
    description: `Expert insights and articles about AWS cloud migration, DevOps, and cloud services from ${contentData.company.name}. Stay updated with the latest cloud technology trends and best practices.`,
    keywords: "Cloud Technology Blog, AWS Insights, Cloud Migration Articles, DevOps Best Practices, Cloud Computing Trends, Technical Articles"
  };

  return (
    <>
      <SEO {...seoData} />

      <section className="py-12 md:py-20 px-4 sm:px-8 md:px-16 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900 flex items-center justify-center">
            <span className="mr-2">📝</span> From Our Blog
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Insights and expert advice on AWS, cloud migration, and DevOps
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogs.map((blog) => (
            <BlogCard key={blog.id} blog={blog} />
          ))}
        </div>

        {blogs.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500">No blog posts available yet. Check back soon!</p>
          </div>
        )}
      </section>
    </>
  );
};

export default BlogPage; 